import { Box, Chip, Collapse, Paper, Stack, Typography, Button } from '@mui/material';
import { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { releases, Release } from './releaseNotes';

// GH-681 — "מה השתנה בגרסה". Reads ./releases.ts (plain text in the repo, updated at every release).

const JIRA = 'https://gh-online.atlassian.net/browse/';
const PLATFORMS: Record<string, string> = { mobile: 'אפליקציה', web: 'אתר', backend: 'שרת', admin: 'אדמין', experts: 'מומחים' };
const heDate = (iso: string) => iso.split('-').reverse().join('.');

const Section = ({ title, items }: { title: string; items: string[] }) =>
	items?.length ? (
		<Box mb={1.5}>
			<Typography variant="subtitle2" color="primary">{title}</Typography>
			<Box component="ul" sx={{ m: 0, pr: 2.5, pl: 0 }}>
				{items.map((t, i) => (
					<Typography key={i} component="li" variant="body2" sx={{ lineHeight: 1.8 }}>{t}</Typography>
				))}
			</Box>
		</Box>
	) : null;

export default function Releases() {
	const [open, setOpen] = useState<Record<string, boolean>>({ [releases[0]?.version]: true });
	return (
		<Box p={2} dir="rtl" maxWidth={900}>
			<Typography variant="h5">גרסאות — מה השתנה</Typography>
			<Typography variant="body2" color="text.secondary" mb={2}>מה נכנס בכל העלאת גרסה, בשפה של בני אדם. הטיקטים מקושרים לג'ירה למי שרוצה לצלול.</Typography>
			{releases.map((r: Release) => (
				<Paper key={r.version} sx={{ p: 2, mb: 1.5 }}>
					<Stack direction="row" spacing={1.5} alignItems="center">
						<Button size="small" onClick={() => setOpen((o) => ({ ...o, [r.version]: !o[r.version] }))}>{open[r.version] ? <FaChevronUp /> : <FaChevronDown />}</Button>
						<Typography variant="h6">גרסה {r.version}</Typography>
						<Typography variant="body2" color="text.secondary">{heDate(r.date)}</Typography>
						{r.platforms.map((p) => <Chip key={p} size="small" label={PLATFORMS[p] || p} />)}
					</Stack>
					<Collapse in={!!open[r.version]}>
						<Box mt={1.5}>
							<Section title="למשתמשים" items={r.users} />
							<Section title="ל-HR ולאדמין" items={r.hr} />
							<Section title="טכני / פנימי" items={r.tech} />
							{r.tickets.length ? (
								<Stack direction="row" spacing={0.5} flexWrap="wrap" mt={1} sx={{ gap: 0.5 }}>
									{r.tickets.map(([key, title]) => <Chip key={key} size="small" variant="outlined" component="a" href={JIRA + key} target="_blank" clickable label={`${key} · ${title}`} />)}
								</Stack>
							) : null}
						</Box>
					</Collapse>
				</Paper>
			))}
		</Box>
	);
}
